import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';

import Request from '@/core/QuRequest';
import ApiDomain from './core/ApiDomain';
import routerMap from './router/index';

const req = new Request();

Vue.use(Router);

const router = new Router(routerMap);

router.beforeEach(async (to, from, next) => {
  // 测试接口切换功能
  ApiDomain.setApiBranch(to.query);

  // 用户直接在地址栏中输入登录页
  const isLoginPage = to.path === '/login' && from.path === '/';
  // 跳转至登录页
  const toLoginPage = to.path === '/login';
  // 从登录页跳转过来
  const fromLoginPage = from.path === '/login';

  // 满足上方三个条件之一则不需要进行鉴权
  if (isLoginPage || toLoginPage || fromLoginPage) {
    next();
  } else {
    // 验证权限
    console.log('前端路由验证');
    const res = await getUserInfo();
    if (res) {
      console.log('已登录');
      next();
    } else {
      console.log('未登录');
      router.push('/login');
      return;
    }
  }
});

router.beforeResolve((to, from, next) => {
  // amis页面配置（若配置了meta/amisPath,将配置query并重定向页面）
  const { amisPath } = to.meta || {};
  if (amisPath && !to.query._path) {
    next({
      path: to.path,
      query: {
        ...(to.query || {}),
        _path: amisPath,
      },
    });
  } else {
    next();
  }
});

// 获取用户信息
async function getUserInfo() {
  try {
    const res = await req.send(req.Apis.sales.user.userInfo);
    if (res.code === 200) {
      return res.data;
    }
    return null;
  } catch (err) {
    Message.error(err.message);
  }
}

export default router;
